// nodemodule imports
import React from 'react';
import styled from "styled-components";
import { withRouter } from 'react-router-dom'


// project imports
import BackButton from "../../reusable/BackButton";
import Swagger from "./Swagger";
import Introduction from "./Introduction";


export default withRouter(({doc, history}) => {

  return (
    <Wrapper>
      <BackButton text={"Back"} onClick={() => history.push('/api-documentation')}/>
      {
        doc === 'Api-docs' ?
          <Swagger/>
          :
          doc === 'Introduction' ?
            <Introduction/>
            :
            null
      }
      </Wrapper>
    )
})


const Wrapper = styled.div(props => ({
  background: "#FFFFFF",
  marginLeft: 350,
  paddingTop: 50,
  paddingBottom: 193,
  "@media (max-width: 1280px)": {
    marginLeft: 330,
  },
   "@media (max-width: 900px)": {
    marginLeft: 30,
  },
}));
